export const ensureDraftPath = (draft: any, path: string[]) => {
  let current = draft;
  for (const segment of path) {
    if (!current[segment]) {
      current[segment] = {};
    }
    current = current[segment];
  }
  return current;
};

export const setDraftValue = (draft: any, path: string, value: any) => {
  const segments = path.split(".");
  const lastSegment = segments.pop()!;
  const target = ensureDraftPath(draft, segments);
  target[lastSegment] = value;
};

export const ensureTypographyField = (draft: any, field: string) => {
  if (!draft.styles) draft.styles = {};
  if (!draft.styles.typography) draft.styles.typography = {};
  if (!draft.styles.typography[field]) {
    draft.styles.typography[field] = {
      fontSize: "12px",
      fontStyle: "regular",
    };
  }
};
